import css from 'styled-jsx/css'

export const styles = css`
  background: #fff;
  padding: 0 20px;
  .author {
    display: flex;
    align-items: center;
    padding: 15px 15px 8px;
  }
  .author :global(.userInfo) {
    overflow: hidden;
    flex: 1;
  }
  .author__button {
    height: 2rem;
    padding: 0 10px;
    border-radius: 5px;
    background-color: #838eff;
    color: #fff;
    text-align: center;
    line-height: 2rem;
  }
`
